import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Flame, ShoppingCart, BookOpen, Users, Mail, MessageSquare, Home, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/services", label: "Services & Readings", icon: Flame },
    { to: "/admin/orders", label: "Orders & Bookings", icon: ShoppingCart },
    { to: "/admin/blog", label: "Journal", icon: BookOpen },
    { to: "/admin/members", label: "Members & Loyalty", icon: Users },
    { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
    { to: "/admin/messages", label: "Messages", icon: MessageSquare },
];

export default function AdminLayout() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const cls = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition-colors ${isActive ? "bg-gold/15 text-gold" : "text-ash hover:text-cream hover:bg-surface2"}`;

    return (
        <div className="min-h-screen bg-ink flex">
            <aside className="w-64 shrink-0 border-r border-gold/10 p-5 hidden md:flex flex-col fixed inset-y-0">
                <Link to="/" className="font-serif text-2xl text-cream px-2">Sacred Earthworks</Link>
                <div className="overline-label px-2 mt-1">Admin</div>
                <nav className="mt-8 space-y-1.5 flex-1">
                    {NAV.map((n) => (
                        <NavLink key={n.to} to={n.to} end={n.end} className={cls} data-testid={`admin-nav-${n.label.split(" ")[0].toLowerCase()}`}>
                            <n.icon className="w-4 h-4" /> {n.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="space-y-1.5 border-t border-gold/10 pt-4">
                    <Link to="/" className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-ash hover:text-cream"><Home className="w-4 h-4" /> View Site</Link>
                    <button onClick={async () => { await logout(); navigate("/"); }} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-ash hover:text-clay"><LogOut className="w-4 h-4" /> Sign Out</button>
                </div>
            </aside>
            <div className="flex-1 md:ml-64">
                <div className="md:hidden flex gap-2 overflow-x-auto p-3 border-b border-gold/10 bg-ink sticky top-0 z-20">
                    {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `whitespace-nowrap text-xs px-3 py-1.5 rounded-full ${isActive ? "bg-gold text-ink" : "text-ash border border-gold/20"}`}>{n.label}</NavLink>)}
                </div>
                <div className="p-6 sm:p-10"><Outlet /></div>
            </div>
        </div>
    );
}
